module.exports = __webpack_public_path__ + "img/flight_car.22895f57.jpg";